import createRoute from '@widesk-ui/tools/createRoute';
import ClientModel from '@models/shop/ClientModel';

export default createRoute.table('/clients', 'shop', 'ClientTable', ClientModel.localize('plural'));
